var map = {
	"./01-full.jpg": "54d7",
	"./01-thumbnail.jpg": "c3f9",
	"./02-full.jpg": "3c01",
	"./02-thumbnail.jpg": "f579",
	"./03-full.jpg": "e58d",
	"./03-thumbnail.jpg": "2f75",
	"./04-full.jpg": "dfa8",
	"./04-thumbnail.jpg": "914f",
	"./05-full.jpg": "110e",
	"./05-thumbnail.jpg": "1757",
	"./06-full.jpg": "68fb",
	"./06-thumbnail.jpg": "bd63"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0ec8";